<div class="guide-section">
  <div class="guide-header">
    <span class="guide-eyebrow">{{ eyebrow }}</span>
    <h2>{{ heading }}</h2>
  </div>

  <details class="guide-step" *ngFor="let step of steps" [open]="step.open">
    <summary>
      <span class="step-num" [class.step-num-alt]="step.alt">{{ step.alt && !step.num ? '×' : step.num }}</span>
      <span class="step-title">{{ step.title }}</span>
      <mat-icon class="step-chevron">chevron_right</mat-icon>
    </summary>
    <div class="step-body" [innerHTML]="step.body"></div>
  </details>

  <p class="guide-footer" *ngIf="footer">{{ footer }}</p>
</div>
